import { _export } from './export';
import { statistics } from './statistics';

export const facebook = {
  export: _export,
  statistics,
};
